module.exports = __webpack_public_path__ + "img/terra.8d8aa21b.jpg";